import CTAButton from '@/components/shared/CTAButton'

const MisSoldSection = ({
  title = 'WERE YOU MIS-SOLD CAR OR MOTOR FINANCE?',
  description = 'The FCA car finance investigation into hidden commissions revealed that lenders allowed brokers and car dealers to increase interest rates to earn better commissions, so you could have paid more without knowing!',
  imageSrc = '/Image/missold-car-claims1.webp',
  imageAlt = 'Mis-sold car finance - Your Claim Matters services',
  backgroundColor = '#ffdcc5',
  imagePosition = 'right',
  textColor = null,
  mobileTextFirst = false,
  showCTA = false,
  ctaText = 'START YOUR CLAIM NOW',
}) => {
  const isImageRight = imagePosition === 'right'

  return (
    <section>
      <div className="flex min-h-[300px] flex-col sm:min-h-[350px] lg:min-h-[300px] lg:flex-row">
        {/* Text Side */}
        <div
          className={`flex items-center justify-center px-4 py-8 sm:px-6 sm:py-10 lg:w-1/2 lg:px-20 lg:py-12 ${
            mobileTextFirst
              ? isImageRight
                ? 'order-1 lg:order-1'
                : 'order-1 lg:order-2'
              : isImageRight
                ? 'order-2 lg:order-1'
                : 'order-2 lg:order-2'
          }`}
          style={{ backgroundColor }}
        >
          <div className="max-w-2xl text-center sm:text-left">
            <h2
              className="mb-4 text-4xl leading-tight font-black sm:text-5xl"
              style={textColor ? { color: textColor } : {}}
              {...(!textColor && {
                className:
                  'text-foreground mb-4 text-4xl leading-tight font-black sm:text-5xl',
              })}
            >
              {title}
            </h2>
            <p
              className="text-base leading-relaxed sm:text-lg"
              style={textColor ? { color: textColor } : {}}
              {...(!textColor && {
                className:
                  'text-foreground text-base leading-relaxed sm:text-lg',
              })}
            >
              {description}
            </p>
            {showCTA && (
              <div className="mt-6">
                <CTAButton text={ctaText} />
              </div>
            )}
          </div>
        </div>

        {/* Photo Side */}
        <div
          className={`relative h-80 sm:h-96 lg:h-auto lg:w-1/2 ${
            mobileTextFirst
              ? isImageRight
                ? 'order-2 lg:order-2'
                : 'order-2 lg:order-1'
              : isImageRight
                ? 'order-1 lg:order-2'
                : 'order-1 lg:order-1'
          }`}
        >
          <img
            src={imageSrc}
            alt={imageAlt}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  )
}

export default MisSoldSection
